import React, { Fragment, PureComponent } from "react";
import styles from "./AccountNumber.module.less";
const R_MASKED_ACCTNUM = /^(\*+)(.+)$/;
export default class AccountNumber extends PureComponent {
    render() {
        const { value } = this.props;
        if (value == null) {
            return null;
        }
        const match = value.match(R_MASKED_ACCTNUM);
        if (match == null) {
            return (<Fragment>
					{value}
				</Fragment>);
        }
        return (<Fragment>
				<span className={styles.mask}>
					{match[1]}
				</span>
				{match[2]}
			</Fragment>);
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/AccountNumber/AccountNumber.tsx